import * as React from "react";
const SvgExport24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 22,
        viewBox: "0 0 24 22",
        fill: "black"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v22h14v-7h-2v5H2V2h10v5h2V0H1Zm17.1 5.785-.716-.7-1.398 1.43.715.7L19.548 10H8v2h11.548L16.7 14.785l-.715.7 1.398 1.43.715-.7 4.6-4.5.731-.715-.73-.715-4.6-4.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgExport24Px;
